import { USER_ROLE_DEFAULTS } from '~/constants/shared';

export default {
  data() {
    return {
      systime: new Date(),
      systimeInterval: null,
    };
  },
  computed: {
    whiteLabel: () => localStorage.getItem('white-label') === 'true',
    userRole() {
      return this.$authentication?.getSession()?.user?.role?.name || USER_ROLE_DEFAULTS.UNKNOWN;
    },
  },
  created() {
    this.systimeInterval = setInterval(() => {
      this.systime = new Date();
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.systimeInterval);
  },
};
